import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/Register.vue'),
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/home/newball_trend_all_companies',
    name: 'newball_trend_all_companies',
    component: () => import('../views/subpages/newball_trend/newball_trend_all_companies.vue'),
  },
  {
    path: '/weekly_items',
    name: 'weekly_items',
    component: () => import('../views/subpages/newball_weekly_items.vue'),
  },
  {
    path: '/newball_trend_second',
    name: 'newball_trend_second',
    component: () => import('../views/subpages/newball_trend/newball_trend_second_standalone.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
